<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'klanttype',
  }"
>
  <ng-template #content>
    <div class="d-flex flex-column gap-2">
      @if (!isSme) {
        <crnt-radio-group>
          <crnt-form-control-label slot="legend">{{
            orderContent().customerTypeSegmentQuestion
          }}</crnt-form-control-label>

          @if (formState().controls.segmentQuestion | isInvalid) {
            @if (formState().controls.segmentQuestion.errors['required']) {
              <crnt-form-control-validation-message>
                {{ orderContent().customerTypeFormError }}
              </crnt-form-control-validation-message>
            }
          }

          @for (
            segmentOption of orderContent().customerTypeSegmentOptions;
            track segmentOption
          ) {
            <crnt-radio>
              <input
                type="radio"
                name="segmentOption"
                [id]="segmentOption.id"
                [value]="
                  mapSitecoreValueToCustomerType(
                    segmentOption.fields['value']?.value
                  )
                "
                [ngrxFormControlState]="formState().controls.segmentQuestion"
              />
              <label slot="label" [for]="segmentOption.id">{{
                segmentOption.fields['label']?.value
              }}</label>
            </crnt-radio>
          }
        </crnt-radio-group>
      }
      @if (
        formState().controls.segmentQuestion.value ===
        ORDER_CUSTOMER_TYPE_OTHER_SEGMENT
      ) {
        @if (formState().controls.companySize; as companySizeControl) {
          <crnt-radio-group>
            <crnt-form-control-label slot="legend">{{
              orderContent().customerTypeCompanySizeQuestion
            }}</crnt-form-control-label>

            @if (formState().controls.companySize | isInvalid) {
              @if (companySizeControl.errors['required']) {
                <crnt-form-control-validation-message>
                  {{ orderContent().customerTypeFormError }}
                </crnt-form-control-validation-message>
              }
            }

            @for (
              sizeOption of orderContent().customerTypeCompanySizeOptions;
              track sizeOption
            ) {
              <crnt-radio>
                <input
                  type="radio"
                  name="sizeOption"
                  [id]="sizeOption.id"
                  [value]="
                    mapSitecoreValueToCustomerType(
                      sizeOption.fields['value']?.value
                    )
                  "
                  [ngrxFormControlState]="companySizeControl"
                />
                <label slot="label" [for]="sizeOption.id">{{
                  sizeOption.fields['label']?.value
                }}</label>
              </crnt-radio>
            }
          </crnt-radio-group>
        }
      }
      <crnt-callout
        variant="informative"
        wlAutomationId="customer-type-info-card"
      >
        <div class="d-flex flex-column gap-2">
          <span class="pl-2">{{ orderContent().customerTypeInfoTitle }}</span>
          <crnt-button
            type="button"
            variant="tertiary"
            (click)="openModal()"
            class="align-self-start w-fit"
            [fullWidth]="false"
          >
            {{ orderContent().customerTypeInfoLink }}
          </crnt-button>
        </div>
      </crnt-callout>
    </div>
  </ng-template>
  <ng-template #summary>
    <span
      *wlGenericRichText="
        orderContent().customerTypeSummaryText
          | interpolate
            : {
                mode: 'rich_text',
                variables: { customerType: readableCustomerType() },
              }
      "
    ></span>
  </ng-template>
</wl-simple-progressive-form-card>
